import React from 'react';
import TreeInfoTable from "./TreeCartTabs/TreeInfoTable";
import TreeCartTable from "./TreeCartTabs/TreeCartTable";
import CutScenariosTable from "./TreeCartTabs/CutScenariosTable";
import {ShoppingCartIcon} from "@phosphor-icons/react";
import PopoutWindow from "../../PopoutWindow";

const TreeCart: React.FC = () => {


    const panes = [
        {
            tab: 'Tree Table',
            key: '1',
            content: <TreeInfoTable/>,
        },
        {
            tab: 'Tree Cart',
            key: '2',
            content: <TreeCartTable/>,
        },
        {
            tab: 'Cut Scenarios',
            key: '3',
            content: <CutScenariosTable/>,
        },
    ];


    return (
        <>
            <PopoutWindow
                iconForButton={<ShoppingCartIcon size={28}/>}
                isOpenByDefault={false}
                panes={panes}
                tooltip={'Show Tree Cart Table'}
                tabTitle={'Tree Cart'}
            />
        </>
    );
};

export default TreeCart;
